module.exports = __webpack_public_path__ + "static/p2-b630ee52ea049f89ee6da23706201a52.jpg";